import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { changePrimary, changeUrl, changeSecondary } from '../../store/actions/colorActions'
import changeWeekendColors from '../../scripts/changeWeekendColors';
import hexToRGBA from '../../scripts/hexToRGBA'

const PickColor = ({ color, changePrimary, changeSecondary, changeUrl }) => {
  const { primary, secondary, url } = color;
  const [primaryOpt, setPrimaryOpt] = useState(primary);
  const [secondaryOpt, setSecondaryOpt] = useState(secondary);
  useEffect(() => { 
    setSecondaryOpt(hexToRGBA(primaryOpt));
    changeWeekendColors(primaryOpt,hexToRGBA(primaryOpt));
    changePrimary(primaryOpt); 
    changeSecondary(secondaryOpt);
    changeUrl(primaryOpt); 
  },[primaryOpt]);
  return ( 
    <div>
      <form className="form">
        <label className="radio-container">
          <input type="radio" name="pick-color" value="#228B22" checked={primaryOpt === "#228B22"} onChange={(e) => setPrimaryOpt(e.target.value)}/>
          <span className="circle radio-forest"></span>
          <p>Forest</p>
        </label>

        <label className="radio-container">
          <input type="radio" name="pick-color" value="#EE82EE" checked={primaryOpt === "#EE82EE"} onChange={(e) => setPrimaryOpt(e.target.value)}/>
          <span className="circle radio-violet"></span>
          <p>Violet</p>
        </label>

        <label className="radio-container">
          <input type="radio" name="pick-color" value="#00BFFF" checked={primaryOpt === "#00BFFF"} onChange={(e) => setPrimaryOpt(e.target.value)}/>
          <span className="circle radio-skyblue"></span>
          <p>Sky Blue</p>
        </label>

        <label className="radio-container">
          <input type="radio" name="pick-color" value="#dc143c" checked={primaryOpt === "#dc143c"} onChange={(e) => setPrimaryOpt(e.target.value)}/>
          <span className="circle radio-crimson"></span>
          <p>Crimson</p>
        </label>

        <label className="radio-container">
          <input type="radio" name="pick-color" value="#DAA520" checked={primaryOpt === "#DAA520"} onChange={(e) => setPrimaryOpt(e.target.value)}/>
          <span className="circle radio-gold"></span>
          <p>Gold</p>
        </label>

        <label className="radio-container">
          <input type="radio" name="pick-color" value="#800080" checked={primaryOpt === "#800080"} onChange={(e) => setPrimaryOpt(e.target.value)}/>
          <span className="circle radio-purple"></span>
          <p>Purple</p>
        </label>
      </form>
    </div>
   );
}
 
const mapStateToProps = state => {
  return {
    color: state.color
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changePrimary: (primary) => dispatch(changePrimary(primary)),
    changeSecondary: (secondary) => dispatch(changeSecondary(secondary)),
    changeUrl: (color) => dispatch(changeUrl(color))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(PickColor);
